import { Button } from "@mui/material";
import wallpaper from "../../../assets/NURSERY 01.jpg";
// import wallpaper from "../../../assets/homeslug2.jpg";

const HomeSlugMobile = () => {
    return (
        <div className="home__container container grid">
            <div style={{
                position: "absolute",
            }} >
                <img
                    src={wallpaper}
                    alt="Nursery Wallpaper"
                    style={{

                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: "-1",
                    }}
                />
            </div>
            <div className="home__data" style={{ paddingLeft: "2rem" , marginTop:"0.5rem"}}>
                <div style={{ position: "relative", display: "inline-block" }}>
                    <h2
                        className="home__title"
                        style={{
                            fontFamily: "Century Gothic",
                            fontSize: "20px",
                            color: "#5a7547",
                            marginBottom: "1rem",
                        }}
                    >
                        GROWING NATURE
                    </h2>
                    <span
                        style={{
                            fontFamily: "Rustic Roadway",
                            fontSize: "20px",
                            color: "#ffff",
                            position: "absolute",
                            bottom: "0.7rem",
                            right: "-20px",
                        }}
                    >
                        growing you
                    </span>
                </div>
                <div style={{ position: "relative" }}>
                    <p
                        className="home__description"
                        style={{
                            fontSize: "12px",
                            color: "#5a7547",
                            lineHeight: "1",
                            fontFamily: "Century Gothic",
                            width:"70%", 
                            fontWeight:"bold"
                           
                        }}
                    >
                        We specialize in providing a diverse range of plants and trees
                        to beautify your surroundings.
                    </p>
                    <Button
                    variant="contained"
                        className="button button--flex"
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent:"center",
                            backgroundColor: "#e67e22",
                            color: "#ffffff",
                            borderRadius: "5px",
                            textDecoration: "none",
                            fontWeight: "bold",
                            fontFamily: "Century Gothic",
                            fontSize:"10px", 
                            transform:"translate(1rem , -1rem)"
                        }}
                    >
                        EXPLORE
                        <i
                            className="ri-arrow-right-down-line button__icon"
                            style={{ marginLeft: "0.5rem" }}
                        ></i>
                    </Button>
                </div>

            </div>
        </div >
        //     <div className="home__container container grid" style={{display:"grid"}}>
        //     <img src={home} alt="" className="home__img" style={{ width: "100%" }} />
        //     <div className="home__data">
        //       <h1 className="home__title">
        //         Plants will make <br /> your life better
        //       </h1>
        //       <p className="home__description">
        //         Create incredible plant design for your offices or apastaments.
        //         Add fresness to your new ideas.
        //       </p>
        //       <a href="#about" className="button button--flex">
        //         Explore <i className="ri-arrow-right-down-line button__icon"></i>
        //       </a>
        //     </div>

        //   </div>

    )
}

export default HomeSlugMobile